/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createContext,
  useCallback,
  useState,
  useContext,
  ReactNode,
} from 'react';

import { BillingProps } from '~/models';

interface BillingDataContextProps {
  billingData: BillingProps;
  handleSaveBillingData(billingInfo: BillingProps): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentProgram: any;
  handleCurrentProgram(currentProgram: any): void;
}

const BillingDataContext = createContext<BillingDataContextProps>(
  {} as BillingDataContextProps,
);

interface BillingDataProviderProps {
  children: ReactNode;
}

function BillingDataProvider({ children }: BillingDataProviderProps) {
  const [currentProgram, setCurrentProgram] = useState({});

  const [billingData, setBillingData] = useState<BillingProps>(
    {} as BillingProps,
  );

  const handleCurrentProgram = useCallback((obj: any) => {
    setCurrentProgram(obj);
  }, []);

  const handleSaveBillingData = useCallback((billingInfo: BillingProps) => {
    setBillingData(billingInfo);
  }, []);

  return (
    <BillingDataContext.Provider
      value={{
        billingData,
        handleSaveBillingData,
        currentProgram,
        handleCurrentProgram,
      }}
    >
      {children}
    </BillingDataContext.Provider>
  );
}

function useAppBillingData(): BillingDataContextProps {
  const context = useContext(BillingDataContext);

  if (!context) {
    throw new Error(
      'useAppBillingData must be used within an BillingDataProvider',
    );
  }

  return context;
}

export { BillingDataProvider, useAppBillingData };
